import { createSelector } from 'reselect'

import { RootState } from '@/store/Reducer'

export const selectWebsalesUsersManagement = (state: RootState) => state.websalesUsersManagement

export const selectWebsalesUsersManagementList = createSelector(
  selectWebsalesUsersManagement,
  websalesUsersManagement => websalesUsersManagement.items,
)

export const selectWebsalesUsersManagementIsLoading = createSelector(
  selectWebsalesUsersManagement,
  websalesUsersManagement => websalesUsersManagement.isLoading,
)

export const selectWebsalesUsersManagementSelected = createSelector(
  selectWebsalesUsersManagement,
  websalesUsersManagement => websalesUsersManagement.selectedWebsalesUser,
)

export const selectWebsalesUsersManagementError = createSelector(
  selectWebsalesUsersManagement,
  websalesUsersManagement => websalesUsersManagement.error,
)
